import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { TypeaheadPaisComponent } from './typeahead';

@NgModule({
    imports: [
        SharedModule,
        TypeaheadModule.forRoot()
    ],
    declarations: [
        TypeaheadPaisComponent
    ],
    exports: [
        TypeaheadPaisComponent,
    ]
})
export class PaisSharedModule { }
